import Dignitary from "../components/Dignitary";
import AboutSchool from "../components/AboutSchool";
import Infrastructure from "../components/Infrastructure";
import Approach from "../components/Approach";
import Achievements from "../components/Achievements";
import GallerySection from "../components/GallerySection";
import TopperStudent from "../components/TopperStudent";
import TopTeachers from "../components/TopTeachers";
import HomeBanner from "../components/HomeBanner";

const Home = () => {
    return (
        <>
            {/* HERO SLIDER */}
            <HomeBanner />

            {/* ABOUT */}
            <AboutSchool />

            {/* INFRASTRUCTURE */}
            <Infrastructure />

            {/* APPROACH */}
            <Approach />

            {/* ACHIEVEMENTS */}
            <Achievements />

            {/* TOP TEACHERS */}
            <TopTeachers />

            {/* TOP Students */}
            <TopperStudent />

            {/* CTA */}
            <GallerySection />

            {/* Dignitaries */}
            <Dignitary />
        </>
    );
}
export default Home;